import { format, toZonedTime } from 'date-fns-tz';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PriceStampType } from '~/components/price-display-view/helpers/price-display-helpers';

import * as S from './PriceCellTooltip.styles';
import { getMarketSessionLabelKey, getTimezoneAbbreviation } from './utils';

export const PriceCellTooltip = ({
  type,
  date,
}: {
  type: PriceStampType;
  date: string;
}) => {
  const { t } = useTranslation(['watchlistManager']);
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneAbbr = getTimezoneAbbreviation(date);

  const lastTradeDate = format(
    date,
    `h:mm:ss a '${timezoneAbbr}' MMMM d, yyyy`,
    {
      timeZone: userTimezone,
    }
  );

  const asOfCloseDate = format(date, `MMMM d, yyyy '${timezoneAbbr}'`, {
    timeZone: userTimezone,
  });

  const zonedDate = toZonedTime(date, 'UTC');
  const lastCloseDate = format(zonedDate, `MMMM d, yyyy '${timezoneAbbr}'`, {
    timeZone: userTimezone,
  });

  const getContent = () => {
    switch (type) {
      case 'live':
        return (
          <>
            <S.TimeLabel>
              {t('watchlistManager:priceCell.asOfDate', {
                date: lastTradeDate,
              })}
            </S.TimeLabel>
            <S.MarketOpenWrapper>
              <S.MarketOpenLabel>
                {t(getMarketSessionLabelKey())}
              </S.MarketOpenLabel>
              <span>·</span>
              <S.LiveDataLabel>
                {t('watchlistManager:priceCell.liveData')}
              </S.LiveDataLabel>
            </S.MarketOpenWrapper>
          </>
        );
      default:
        const dateToUse = type === 'notLive' ? asOfCloseDate : lastCloseDate;
        return (
          <>
            <S.TimeLabel>{dateToUse}</S.TimeLabel>
            <S.AsOfLastCloseLabel>
              {t('watchlistManager:priceCell.asOfLastClose')}
            </S.AsOfLastCloseLabel>
          </>
        );
    }
  };

  return <S.Root>{getContent()}</S.Root>;
};
